<template>
  <VModal class="modal-not-service-area" :radius="4">
    <VBlock slot="header" :direction="Direction.column">
      <VImage
        :src="resources.PopupIcon"
        class="modal-not-service-area-image"
        :width="144"
        :height="144"
      />
      <VP text="앗, 현재 위치에서 B마트를" :size="16" :spacing="-0.38" />
      <VP text="이용하실 수 없어요" :size="16" :spacing="-0.38" />
    </VBlock>
    <!-- <VP slot="contents" class="content-text" :color="TextColor.disable" :text="message" :size="16" /> -->
    <VBlock slot="footer" class="button-wrapper">
      <VButton class="button" :color="ButtonColor.none" :onClick="onCancel">
        <VSpan text="닫기" :size="16" :color="TextColor.black" :spacing="-0.38" />
      </VButton>

      <VButton class="button" :color="ButtonColor.none" :onClick="onOK">
        <VSpan
          class="text"
          text="현재 위치 변경"
          :size="16"
          :color="TextColor.black"
          :weight="TextWeight.bold"
          :spacing="-0.4"
        />
      </VButton>
    </VBlock>
  </VModal>
</template>

<script>
import VImage from '@/presentationals/v2/components/layouts/atoms/VImage'
import VButton, { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'
import VP from '@/presentationals/v2/components/layouts/atoms/VP'
import VSpan, { TextColor, TextWeight } from '@/presentationals/v2/components/layouts/atoms/VSpan'

import VBlock, { Direction } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VModal from '@/presentationals/v2/components/layouts/molecules/VModal'

import PopupIcon from '@/assets/images/review-popup-90@2x.png'

export default {
  name: 'ModalNotServiceArea',
  props: {
    onOK: {
      type: Function,
      required: true
    },
    onCancel: {
      type: Function,
      required: true
    }
  },
  components: {
    VImage,
    VButton,
    VSpan,
    VP,
    VBlock,

    VModal
  },
  data() {
    return {
      ButtonColor,
      TextColor,
      TextWeight,
      Direction,

      resources: {
        PopupIcon
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';
/* 
.header-text,
.content-text {
  text-align: left;
  letter-spacing: -0.38px;
  line-height: 1.38;
} */

.modal-not-service-area {
  & .modal-not-service-area-image {
    margin-bottom: 20px;
  }
}

.button-wrapper {
  .button {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    box-sizing: border-box;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
    }
    &:first-child {
      padding-right: 1px;
      border-right: 1px solid $light-gray-5;
    }

    &:last-child {
      /* border-left: 1px solid $light-gray-5; */
    }

    & .text {
      white-space: nowrap;
    }
  }
}
</style>